/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-14 10:58:25
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 11:19:31
 */
import VueSocketIO from "vue-socket.io";
import { myUtils } from "./utils";
const isdev = process.env.NODE_ENV == "development";

function concatUrl(domain) {
  const id = myUtils.getUrlParms("id");
  if (!id) {
    return;
  }
  const [, , , , appId] = id.split("|");
  if (!appId) {
    return "";
  }
  let h5AppId = appId.split("_");
  h5AppId[0] = "h5";
  h5AppId = h5AppId.join("_");
  return `${domain}?appId=${h5AppId}`;
}

/**
 * 监听是否后台
 * 解决 后台运行时 系统强制关闭socket连接
 * 当后台运行时 主动关闭socket链接 socket.close();
 * 切换到前台运行 主动打开连接 socket.open();
 */
document.addEventListener("visibilitychange", () => {
  if (window.vm && window.vm.$socket) {
    const socket = window.vm.$socket;
    if (document.hidden) {
      socket.close();
    } else {
      socket.open();
    }
  }
});

/**
 * 订阅socket事件
 */
function subscribe() {
  window.vm.sockets.subscribe("onMessageFromPayBack", result => {
    console.log('socket onMessageFromPayBack', result);
    window.onMessageFromPayBack(result.data.payload);
  });
  window.vm.sockets.subscribe("onMessageFromLoginBack", result => {
    const { type, userId, sessionId } = result.data.payload;
    console.log('socket onMessageFromLoginBack', result.data.payload);
    window.onMessageFromLoginBack(type, userId, sessionId);
  });
}
/**
 * 取消事件订阅
 */
function unsubscribe() {
  window.vm.sockets.unsubscribe("onMessageFromPayBack");
  window.vm.sockets.unsubscribe("onMessageFromLoginBack");
}
function init(domain){
  let io = null
  return new Promise(resolve=>{
    const url = concatUrl(domain);
    if(url){
      io = new VueSocketIO({
        debug: isdev,
        connection: url,
        options: {
          transports: ["websocket"]
        }
      })
    }
    resolve({ io, subscribe, unsubscribe })
  })
}
export default init;
